import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1918328733__a" }, [
        _createElementVNode("rect", {
          width: "24",
          height: "24",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i1918328733__a)" }, [
      _createElementVNode("path", {
        fill: "#743A3A",
        d: "M2.903 1.5v20.207a.79.79 0 0 0 1.199.678l7.906-3.036 7.89 3.034a.79.79 0 0 0 1.2-.677V1.5H2.903ZM16.55 9.91l-1.809 1.854.42 2.574a.685.685 0 0 1-1.007.71L12 13.86l-2.153 1.191a.686.686 0 0 1-1.009-.708l.42-2.575-1.81-1.855a.685.685 0 0 1 .386-1.157l2.47-.378 1.073-2.285a.686.686 0 0 1 1.242 0l1.073 2.287 2.47.378c.553.08.78.753.39 1.151Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "latestNews2"}) } }